(function () {
  const config = window.__productNavConfig;
  if (!config) return;

  const STOREFRONT_API_URL = 'https://eleganz-juwelier.de/api/2024-01/graphql.json';
  const STOREFRONT_TOKEN = '93dcd7e39588061fad9bc1f8cc4da5e5';

  const query = `
    query getCollectionProducts($handle: String!, $cursor: String) {
      collection(handle: $handle) {
        products(first: 250, after: $cursor) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            handle
          }
        }
      }
    }
  `;

  async function fetchAllProducts(handle) {
    let allHandles = [];
    let cursor = null;
    let hasNextPage = true;

    while (hasNextPage) {
      const res = await fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query,
          variables: { handle, cursor }
        })
      });

      const { data } = await res.json();
      const products = data?.collection?.products;

      if (!products) break;

      allHandles = allHandles.concat(products.nodes.map(p => p.handle));
      hasNextPage = products.pageInfo.hasNextPage;
      cursor = products.pageInfo.endCursor;
    }

    return allHandles;
  }

  const productNav = {
    handles: [],
    currentIndex: -1,
    loaded: false,

    async init() {
      const handle = config.collectionMap[config.category];
      if (!handle) return;

      try {
        this.handles = await fetchAllProducts(handle);
        this.currentIndex = this.handles.indexOf(config.currentHandle);
        this.loaded = true;
        this.updateButtons();
      } catch (e) {
        console.warn('Product nav error:', e);
      }
    },

    updateButtons() {
      const prev = document.getElementById('btn-prev');
      const next = document.getElementById('btn-next');
      if (!prev || !next) return;

      prev.classList.remove('product-nav-btn--disabled');
      next.classList.remove('product-nav-btn--disabled');

      if (this.handles.length === 0) return;

      if (this.currentIndex <= 0) prev.classList.add('product-nav-btn--disabled');
      if (this.currentIndex >= this.handles.length - 1) next.classList.add('product-nav-btn--disabled');
    },

    go(direction) {
      if (!this.loaded || this.handles.length === 0) return;

      let target;

      if (direction === 'prev') {
        if (this.currentIndex <= 0) return;
        target = this.handles[this.currentIndex - 1];
      } else if (direction === 'next') {
        if (this.currentIndex >= this.handles.length - 1) return;
        target = this.handles[this.currentIndex + 1];
      } else if (direction === 'random') {
        let i;
        do { i = Math.floor(Math.random() * this.handles.length); }
        while (i === this.currentIndex && this.handles.length > 1);
        target = this.handles[i];
      }

      if (target) window.location.href = '/products/' + target;
    }
  };

  window.productNav = productNav;
  document.addEventListener('DOMContentLoaded', () => productNav.init());
})();
